import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/jquery.fittext.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

$(document).ready(function(){
  $('.ny-banner h1').textillate();
  if($('.ny-banner h2').html() != ''){
    setTimeout(function(){
      $('.ny-banner h2').textillate();
    },800)
  }

  var swiper1 = new Swiper(".partner1 .mySwiper", {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 20,
    breakpoints: { //响应式
      768: {  //当屏幕宽度大于等于768 
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      1024: {  //当屏幕宽度大于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 40,
      }
    },
    pagination: {// 分页
      el: ".partner1 .swiper-pagination",
      clickable: true,
    },
    navigation: {//按钮
      nextEl: ".partner1 .swiper-button-next",
      prevEl: ".partner1 .swiper-button-prev",
    },
  })

  var swiper2 = new Swiper(".partner2 .mySwiper", {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 20,
    breakpoints: { //响应式
      768: {  //当屏幕宽度大于等于768 
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      1024: {  //当屏幕宽度大于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 40,
      }
    },
    pagination: {// 分页
      el: ".partner2 .swiper-pagination",
      clickable: true,
    },
    navigation: {//按钮
      nextEl: ".partner2 .swiper-button-next",
      prevEl: ".partner2 .swiper-button-prev",
    },
  })

  var swiper3 = new Swiper(".partner3 .mySwiper", {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 20,
    grid: {
      fill: 'row',
      rows: 2,
    },
    breakpoints: { //响应式
      768: {  //当屏幕宽度大于等于768 
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      1024: {  //当屏幕宽度大于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 40,
      }
    },
    pagination: {// 分页
      el: ".partner3 .swiper-pagination",
      clickable: true,
    },
    navigation: {//按钮
      nextEl: ".partner3 .swiper-button-next",
      prevEl: ".partner3 .swiper-button-prev",
    },
  })
})